export const textStep = {
    'identification_data' : {
        title: 'Dados de identificação',
        description: 'Precisamos de alguns dados e fotos da frente e verso do seu RG ou CNH para comprovarmos sua identidade',
        image: 'images/new-check-icon.svg'
    },
    'residence_data': {
        title: 'Sobre seu endereço',
        description: '',
        image: 'images/bb/ourocard-novo.png'
    },
    'default': {
        title: 'Precisamos de mais algumas informações',
        description: 'Quase lá! Precisamos de alguns documentos para validar seus dados',
        image: 'images/bb/ourocard-novo.png'
    }
}